export default "/assets/Image/click-arrow.png"